import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import PortalEditRoutes from './routes'

const PortalEdit = () => {
  const { portalId } = useNumericParams()

  useReduxAction(
    'portals',
    'loadPortal',
    {
      entityId: portalId,
      include_portal_auth_details: true,
    },
    [portalId],
    {
      dispatchAction: (action, requestOptions) => action(portalId, requestOptions),
      // @ts-expect-error TS2339
      shouldPerformFn: ({ loading }) => !!portalId && !loading,
    },
  )

  return (
    <PortalEditRoutes />
  )
}

export default PortalEdit
